import { PropsWithChildren, PureComponent } from 'react';

interface ImageProps {
    url: string;
    width?: string;
    height?: string;
    [key: string]: any;
}

export class Image extends PureComponent<PropsWithChildren<ImageProps>> {
    render() {
        const { url, ...rest } = this.props;
        return <img src={`/assets/img/${url}`} {...rest} />;
    }
}
